"use client";

const PopularAppLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d={`M12.9298 10.7816C12.7839 11.5963 12.3919 12.3468 11.8066 12.932C11.2213 13.5172 10.4708 13.909 9.65602 14.0547C9.62509 14.0596 
        9.59382 14.0622 9.5625 14.0624C9.4214 14.0623 9.28547 14.0093 9.18166 13.9137C9.07786 13.8182 9.01376 13.6871 9.00208
         13.5465C8.9904 13.4058 9.03199 13.266 9.1186 13.1546C9.20522 13.0432 9.33053 12.9684 9.46969 12.9451C10.6348 12.7489 
         11.6234 11.7604 11.8209 10.5932C11.8459 10.446 11.9283 10.3149 12.05 10.2285C12.1718 10.1421 12.3228 10.1076 12.4699 
         10.1326C12.6171 10.1576 12.7482 10.24 12.8346 10.3617C12.921 10.4834 12.9555 10.6345 12.9305 10.7816H12.9298ZM15.1875 
         10.1249C15.1875 11.7659 14.5356 13.3397 13.3752 14.5001C12.2148 15.6605 10.641 16.3124 9 16.3124C7.35897 16.3124 5.78516 
         15.6605 4.62478 14.5001C3.4644 13.3397 2.8125 11.7659 2.8125 10.1249C2.8125 8.16176 3.58594 6.15434 5.10891 4.15887C5.15711 
         4.09569 5.21816 4.04343 5.28803 4.00556C5.3579 3.96768 5.43501 3.94504 5.51426 3.93913C5.59352 3.93322 5.67313 3.94416 5.74784 
         3.97125C5.82256 3.99834 5.89068 4.04096 5.94773 4.09629L7.64367 5.74231L9.19055 1.49473C9.22145 1.41001 9.27227 1.33397 9.33872 
         1.27301C9.40517 1.21204 9.4853 1.16795 9.57236 1.14445C9.65942 1.12094 9.75086 1.11871 9.83896 1.13794C9.92706 1.15718 10.0093 1.19731 
         10.0786 1.25496C11.6163 2.53114 15.1875 5.94481 15.1875 10.1249ZM14.0625 10.1249C14.0625 6.88418 11.546 4.08364 9.96961 2.64856L8.40375 
         6.94254C8.37161 7.03074 8.31792 7.10948 8.24755 7.17161C8.17719 7.23374 8.0924 7.27727 8.0009 7.29824C7.90941 7.31921 7.81412 7.31695
          7.72373 7.29166C7.63333 7.26638 7.5507 7.21888 7.48336 7.15348L5.62922 5.35489C4.50633 6.97559 3.9375 8.57801 3.9375 10.1249C3.9375 
          11.4675 4.47087 12.7552 5.42027 13.7046C6.36967 14.654 7.65734 15.1874 9 15.1874C10.3427 15.1874 11.6303 14.654 12.5797 13.7046C13.5291 
          12.7552 14.0625 11.4675 14.0625 10.1249Z`}
        fill="#FAAD14"
      />
    </svg>
  );
};

export default PopularAppLogo;
